import { create } from "@hermes/shared/src/redux/store/store";
import { getService, getClient } from "..";

export const store = create(getService(), getClient());